import {
    updateStateAfterWidgetOptionChange,
    isMdaeWidgetOptionChangeEvent,
} from "../../mdae-framework";
import { cloneDeep } from 'lodash';
import { actionTypes as asyncTypes, isAsyncOperation, isAsyncComplete, isAsyncFailure } from 'async-ops';
import { GET_CASE_FIELDS_TAB_REFERENCE_DATA } from "../services/get-case-fields-tab-reference-data";
export const SET_CASE_FIELDS_TAB_FLAGS = 'SET_CASE_FIELDS_TAB_FLAGS';
export const TOGGLE_CASE_SUMMARY_DRAWER = 'TOGGLE_CASE_SUMMARY_DRAWER';
export const TOGGLE_LINE_DATAGRID_SHOW_ALL_FIELDS_VIEW = 'TOGGLE_LINE_DATAGRID_SHOW_ALL_FIELDS_VIEW';
export const SET_SELECTED_AUDIT_ID = 'SET_SELECTED_AUDIT_ID';
export const SET_AUDIT_CASE_LINES = "SET_AUDIT_CASE_LINES";

const initialError = {
    code: '',
    message: '',
    value: []
};
export const initialCaseFieldsTabFlags ={
    isInPatient: false,
    isOutPatient: false,
    isProfessional: false,
}
const initialCaseFieldsTabReferenceData = {
    eaCaseLinkedAuditsData: [],
    mostRecentAuditData: {},
}
const initialState = {
    loading: false,
    error: initialError,
    caseFieldsTabFlags: {},
    isCaseSummaryDrawerVisible: false,
    isLineDataGridShowAllField: false,
    caseFieldsTabReferenceData: initialCaseFieldsTabReferenceData,
    selectedAuditId: 0,
    selectedCaseDetailIdsToAttachDocument: [],
};

export default (state = initialState, action) => {
    let newState;
    switch (action.type) {
      case asyncTypes.OPERATION:
      case asyncTypes.COMPLETE:
      case asyncTypes.FAILURE:
        if (isAsyncComplete(GET_CASE_FIELDS_TAB_REFERENCE_DATA)(action)) {
          return {
            ...state,
            caseFieldsTabReferenceData: { ...action.response },
            selectedAuditId:
              action.response?.mostRecentAuditData?.linkedAuditId,
          };
        }
        return state;
      case TOGGLE_CASE_SUMMARY_DRAWER:
        newState = {
          ...state,
          isCaseSummaryDrawerVisible: !state.isCaseSummaryDrawerVisible,
        };
        return newState;
      case TOGGLE_LINE_DATAGRID_SHOW_ALL_FIELDS_VIEW:
        newState = {
          ...state,
          isLineDataGridShowAllField: !state.isLineDataGridShowAllField,
        };
        return newState;
      case SET_CASE_FIELDS_TAB_FLAGS:
        return {
          ...state,
          caseFieldsTabFlags: { ...state.caseFieldsTabFlags, ...action.data },
        };
      case SET_SELECTED_AUDIT_ID:
      case SET_AUDIT_CASE_LINES:
        newState = cloneDeep(state);
        if (isMdaeWidgetOptionChangeEvent(action.data)) {
          newState = updateStateAfterWidgetOptionChange(newState, action.data);
        } else {
          newState = { ...newState, ...action.data };
        }
        return newState;     
        
      default:
        return state;
    }
};
